import {CommonStatus} from "@/enums/status";

export class RoleParams {
    page? = 1;
    limit? = 10;
    type?: string;
    status? = CommonStatus.Active;
    postOfficeRowGuid?: string;
}
